import { render } from "./FlashedMessages.vue?vue&type=template&id=49a9392a&scoped=true"
import script from "./FlashedMessages.vue?vue&type=script&lang=js"
export * from "./FlashedMessages.vue?vue&type=script&lang=js"

import "./FlashedMessages.vue?vue&type=style&index=0&id=49a9392a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a9392a"]])

export default __exports__